// Actions
const TOGGLE_DROPDOWN = 'zen/notification/TOGGLE_DROPDOWN';
const CLOSE_DROPDOWN = 'zen/notification/CLOSE_DROPDOWN';
const FETCH_NOTIFICATIONS = 'zen/notification/FETCH_NOTIFICATIONS';
const FETCH_NOTIFICATIONS_SUCCEEDED = 'zen/notification/FETCH_NOTIFICATIONS_SUCCEEDED';
const FETCH_NOTIFICATIONS_FAILED = 'zen/notification/FETCH_NOTIFICATIONS_FAILED';
const UPDATE_READ_FLAG = 'zen/notification/UPDATE_READ_FLAG';
const NOTIFICATION_RECEIVED = 'zen/notification/NOTIFICATION_RECEIVED';

import { JOIN_ROOM, LEAVE_ROOM } from 'actions';

let socketMessage;

const initialState = {
  isOpen: false,
  loading: false,
  fetchNotificationsError: null,
  notifications: [],
  unreadCount: 0,
  total: 0,
  offset: 0
};

// Reducer
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return {...state, loading: true};
    case TOGGLE_DROPDOWN:
      return {...state, isOpen: !state.isOpen};
    case CLOSE_DROPDOWN:
      return {...state, isOpen: false};
    case FETCH_NOTIFICATIONS_SUCCEEDED:
      return {
        ...state,
        notifications: state.notifications.concat(action.payload.docs),
        loading: false,
        unreadCount: action.payload.unread,
        fetchNotificationsError: null,
        total: parseInt(action.payload.total, 10),
        offset: parseInt(action.payload.offset, 10) + 20
      };
    case FETCH_NOTIFICATIONS_FAILED:
      return {...state, fetchNotificationsError: action.payload, notifications: null};
    case UPDATE_READ_FLAG:
      return {...state, unreadCount: 0};
    case NOTIFICATION_RECEIVED:
      socketMessage = action.data;
      return {
        ...state,
        unreadCount: state.unreadCount + socketMessage.length,
        notifications: [...socketMessage, ...state.notifications]
      };
    default: return state;
  }
};

// Action Creators
const toggleDropdown = () => {
  return { type: TOGGLE_DROPDOWN };
};

const closeDropdown = () => {
  return { type: CLOSE_DROPDOWN };
};

const fetchNotifications = (userId) => {
  return { type: FETCH_NOTIFICATIONS, userId };
};

const fetchNotificationsSucceeded = (payload) => {
  return { type: FETCH_NOTIFICATIONS_SUCCEEDED, payload };
};

const fetchNotificationsFailed = (payload) => {
  return { type: FETCH_NOTIFICATIONS_FAILED, payload };
};

const updateReadFlag = (userId) => {
  return { type: UPDATE_READ_FLAG, userId };
};

// dispatch to saga to take care of socket connection/disconnection
const joinNotificationRoom = (userId) => {
  const redisChannelId = `notify|user|${userId}`;
  return { type: JOIN_ROOM, payload: {room_type: 'notifications', redis_channel_id: redisChannelId} };
};

const leaveNotificationRoom = (userId) => {
  const redisChannelId = `notify|user|${userId}`;
  return { type: LEAVE_ROOM, payload: {room_type: 'notifications', redis_channel_id: redisChannelId} };
};

export default reducer;
export {
  // Actions
  TOGGLE_DROPDOWN,
  CLOSE_DROPDOWN,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCEEDED,
  FETCH_NOTIFICATIONS_FAILED,
  UPDATE_READ_FLAG,
  JOIN_ROOM,
  LEAVE_ROOM,
  NOTIFICATION_RECEIVED,
  // Action Creators
  toggleDropdown,
  closeDropdown,
  fetchNotifications,
  fetchNotificationsSucceeded,
  fetchNotificationsFailed,
  updateReadFlag,
  joinNotificationRoom,
  leaveNotificationRoom
};
